import { FilterDataSelect, Table } from '@fullscreendigital/carrefour-dex-fe'
import s from './MetiReport.modules.scss'
import { useMemo, useRef, useState } from 'react'
import { getColumns, getRows } from './helpers'
import { Box, Grid } from '@mui/material'
import { useReactToPrint } from 'react-to-print'
import { PrintButton } from './PrintButton'
import { PrintDocument } from './PrintDocument'
import { useQuery } from 'react-query'
import { makeCoreGetRequest } from '../../../utils/api'
import { useSearchParams } from 'react-router-dom'
import { toWasteCategory } from './serializers'
import { getWasteCategoryOptions } from '../api'
import { useNotification } from '../../../hooks'
import { handleQueryError } from 'utils/helpers'

const MetiReports = () => {
  const [searchParams] = useSearchParams()
  const dailyReportId = searchParams.get('dailyReportId')
  const metiReportId = searchParams.get('metiReportId')

  const [selectedCategories, setSelectedCategories] = useState([])

  const columns = useMemo(() => getColumns(), [])

  const componentRef = useRef(null)
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  })

  const { showNotification } = useNotification()

  const metiReportQuery = useQuery(
    ['meti-report-query', dailyReportId, metiReportId],
    async () => {
      let response
      if (dailyReportId) {
        response = await makeCoreGetRequest(
          `/waste-management-system/meti-reports/articles?filterBy=dailyReportId&filterValue=${dailyReportId}`
        )
      } else if (metiReportId) {
        response = await makeCoreGetRequest(
          `/waste-management-system/meti-reports/articles?filterBy=metiReportId&filterValue=${metiReportId}`
        )
      }
      return response.wasteCategories.map(wasteCategory => toWasteCategory(wasteCategory))
    },
    {
      initialData: [],
      onError: error =>
        handleQueryError(error, 'A aparut o eroare la obtinerea raportului meti.', showNotification)
    }
  )

  const wasteCategoriesQuery = getWasteCategoryOptions(showNotification)

  return (
    <div className={s.mainContainer}>
      <Grid container justifyContent="flex-end" gap={2} alignItems="flex-end">
        {!dailyReportId && (
          <FilterDataSelect
            label="Selecteaza Categorie"
            options={wasteCategoriesQuery.data || []}
            defaultSelectedData={selectedCategories}
            name=""
            onSelect={value => {
              setSelectedCategories(value)
            }}
            multiSelect
          />
        )}
        <PrintButton onClick={handlePrint} />
      </Grid>
      <PrintDocument
        componentRef={componentRef}
        metiReport={metiReportQuery.data}
        // reportDate={'10/10/2024'}
      />
      <Box>
        {(selectedCategories.length > 0
          ? metiReportQuery.data.filter(wasteCategory =>
              selectedCategories.some(sc => sc.label === wasteCategory.categoryName)
            )
          : metiReportQuery.data
        ).map(wasteCategory => (
          <Box className={s.tableContainer}>
            <Box className={s.categoryName}>{wasteCategory.categoryName}</Box>
            <Table
              hideCheckbox={true}
              isLoading={false}
              columns={columns}
              rows={[...wasteCategory?.articles, ...getRows(wasteCategory)]}
              disablePagination
            />
          </Box>
        ))}
      </Box>
    </div>
  )
}

export default MetiReports
